import { useMemo } from "react";
import type { LinkItem } from "src/http/api-types";

interface SportData {
  leagues: Record<number, { teams: LinkItem[] }>;
  teams: LinkItem[];
}

/**
 * Composes Data Structures to Represent a Sport's Teams, League's Division Details + Respective Teams & League Details + Respective Teams
 */
export const useSportData = (teamsList: readonly LinkItem[]) =>
  useMemo(
    () =>
      teamsList.reduce(
        (acc: SportData, team): SportData => {
          const { leagueDetails } = team;
          const { leagues } = acc;
          const currLeague = leagueDetails?.contentId ? leagues[leagueDetails.contentId] : undefined;

          return {
            ...acc,
            leagues: {
              ...leagues,
              ...(currLeague
                ? {
                    [leagueDetails?.contentId ?? ""]: {
                      ...currLeague,
                      teams: [...currLeague.teams, team],
                    },
                  }
                : {
                    [leagueDetails?.contentId ?? ""]: {
                      ...leagueDetails,
                      teams: [team],
                    },
                  }),
            },
          };
        },
        { leagues: {}, teams: [] } satisfies SportData,
      ),
    [teamsList],
  );
